module.exports = __webpack_public_path__ + "img/pause.1867b6b8.svg";